import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async loadFAQ( _, params){
      return await axios.get('/superadmin/faqs', { params })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async createFAQ( _, formData){
      return await axios.post('/superadmin/faqs', formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateFAQ( _, {id, formData}){
      return await axios.post(`/superadmin/faqs/${id}`, formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async deleteFAQ( _, id){
      return await axios.delete(`/superadmin/faqs/${id}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
  },
};
